import { useFetchStoriesQuery } from '../Api/Story/storySlice';
import StoryCard from './StoryCard';

export default function Feed() {
	const { data: stories, isLoading } = useFetchStoriesQuery(undefined);

	return (
		<div className=''>
			{!isLoading &&
				stories &&
				stories.length > 0 &&
				stories.map((story, index) => (
					<StoryCard
						key={`story-${String(index)}`}
						story={story}
					/>
				))}
		</div>
	);
}
